import React from "react";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  InputLabel,
} from "@material-ui/core";
import { ReactSVG } from "react-svg";
import checkBoxCheckIcon from "Assets/svg/icon/checkBoxCheckIcon.svg";
import checkedBoxIcon from "Assets/svg/icon/checkedBoxIcon.svg";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";

function MuiRadioGroup({
  items,
  valueKey = "value",
  labelKey = "label",
  onChange,
  // size = "small",
  className,
  label,
  value,
  translate,
  name,
  ...props
}) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  return (
    <FormControl
      dir={direction}
      component="fieldset"
      className={`radioGroup ${className}`}
      {...props}
    >
      <InputLabel>{label}</InputLabel>
      <div className="inner-radio-group">
        {Object.keys(items).map((key) => {
          if (Object.entries(items[key]).length !== 0) {
            return (
              <RadioGroup
                key={key}
                value={value ? value[valueKey] : ""}
                onChange={() => onChange(name, key, items[key])}
              >
                <FormControlLabel
                  value={items[key][valueKey]}
                  control={<Radio />}
                  disabled={items[key]?.disabled}
                  label={
                    <span>
                      {translate ? t(items[key].key) : items[key][labelKey]}
                    </span>
                  }
                />
              </RadioGroup>
            );
          } else {
            return null;
          }
        })}
      </div>
    </FormControl>
  );
}

export default MuiRadioGroup;
